import React from 'react';
import Header from './Header';
import rensImage from '../assets/images/rens.webp';
import Footer from './Footer';
import Navbar from './Navbar';

function MainContainer({ children }: { children: React.ReactNode }) {
    return (
        <div className='min-h-screen flex flex-col relative'>
            <div className='absolute top-0 right-0 z-0 hidden lg:block lg:w-[38%] lg:h-screen'>
                <img
                    src={rensImage}
                    alt='Profile'
                    className='w-full h-full object-cover'
                    style={{
                        WebkitMaskImage: 'linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 20%)',
                        maskImage: 'linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 20%)',
                    }}
                />
            </div>
            <div className='relative z-10 flex flex-grow'>
                <div className='flex-grow'>
                    <Header title='Rens ter Weijde' />
                    <Navbar />
                    <div className='px-6 py-4 max-w-[100%] lg:max-w-[60%] lg:px-20 lg:py-8'>
                        {children}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default MainContainer;
